import { DEFAULT_PARAMS } from '@constants';
import { IParams } from 'interfaces';
import { SURVEY_CONFIG, LANGUAGES } from 'types';

export const withDefaultParams = (obj: { [k: string]: any }): IParams => {
	const result = obj;
	Object.entries(DEFAULT_PARAMS).forEach(([key, value]) => {
		result[key as keyof IParams] =
			obj[key] === 'true' ? true : obj[key] === 'false' ? false : obj[key] ?? value;
	});
	const params = result as IParams;

	// set eng only for academy config
	if (
		params.config === SURVEY_CONFIG.ACADEMY ||
		params.config === SURVEY_CONFIG.ACADEMYV2 ||
		params.config === SURVEY_CONFIG.ACADEMYV3 ||
		params.config === SURVEY_CONFIG.ACADEMYV3FSV2
	) {
		params.force_lang = LANGUAGES.EN;
	}

	const extendedResult = setCustomParameters(params);

	return extendedResult as IParams;
};

const setCustomParameters = (obj: { [k: string]: any }): { [k: string]: any } => {
	const params = obj;

	const forceEngLang = params.paypal_to_stripeV0 === 'true' || params.paypal_to_stripeV1 === 'true';
	// params.fsv1f1 === 'true' ||
	// params.fsv1f2 === 'true' ||
	// params.fsv1f3 === 'true' ||
	// params.fsv1m1 === 'true' ||
	// params.fsv1m2 === 'true' ||
	// params.fsv1m3 === 'true';

	params.force_lang = forceEngLang ? 'en' : params.force_lang ?? undefined;

	// if (!params.force_lang) {
	// 	const forceEngLang = true;
	// 	params.force_lang = forceEngLang ? 'en' : params.force_lang ?? undefined;
	// }

	return params;
};
